import { PublicClientApplication, AccountInfo } from '@azure/msal-browser';
import { getPartnerSettings } from './partnerSettings';
import { getI18n } from 'react-i18next';

// eslint-disable-next-line no-undef
const SCOPES = (process.env.REACT_APP_AZURE_SCOPES ?? '').split(' ');

let azureClient: PublicClientApplication;
let account: AccountInfo;
let guestAccessToken: string;

export const getAccessToken = async (force?: boolean): Promise<string | undefined> => {
  if (guestAccessToken) {
    return guestAccessToken;
  }
  const settings = getPartnerSettings();
  const partnerName = process.env.REACT_APP_PARTNER_NAME ?? '';

  try {
    const result = await azureClient.acquireTokenSilent({
      scopes: SCOPES,
      account,
      forceRefresh: force,
      extraQueryParameters: {
        logoUrl: encodeURIComponent(settings?.logoUrl),
        weChoooseSignupLink: encodeURIComponent(`${window.origin}/signup/wechooose`),
        colors: encodeURIComponent(JSON.stringify(settings?.colors)),
        faviconUrl: encodeURIComponent(settings?.faviconUrl),
        disableSignupLink: encodeURIComponent(`${settings?.disableSignupLink ?? false}`),
        lng: encodeURIComponent(`${getI18n().language || 'en'}`),
        partnerName: encodeURIComponent(partnerName),
      },
    });

    return result?.accessToken ?? '';
  } catch (err) {
    await azureClient.acquireTokenRedirect({
      scopes: SCOPES,
      account,
      extraQueryParameters: {
        logoUrl: encodeURIComponent(settings?.logoUrl),
        weChoooseSignupLink: encodeURIComponent(`${window.origin}/signup/wechooose`),
        colors: encodeURIComponent(JSON.stringify(settings?.colors)),
        faviconUrl: encodeURIComponent(settings?.faviconUrl),
        disableSignupLink: encodeURIComponent(`${settings?.disableSignupLink ?? false}`),
        lng: encodeURIComponent(`${getI18n().language || 'en'}`),
        partnerName: encodeURIComponent(partnerName),
      },
    });
  }
};

export const setAzureClient = (client: PublicClientApplication): void => {
  azureClient = client;
};

export const getAzureClient = (): PublicClientApplication => {
  return azureClient;
};

export const setCurrentAccount = (currentAccount: AccountInfo): void => {
  account = currentAccount;
};

export const setGuestAccessToken = (token: string): void => {
  guestAccessToken = token;
};

export const getAuthAccount = (): AccountInfo => {
  return account;
};
